import { render, staticRenderFns } from "./IntegrationPartners.vue?vue&type=template&id=a8dfbce8&"
import script from "./IntegrationPartners.vue?vue&type=script&lang=js&"
export * from "./IntegrationPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports